const provinceEn = {
  "กระบี่": "Krabi",
  "กรุงเทพมหานคร": "Bangkok",
  "กาญจนบุรี": "Kanchanaburi",
  "กาฬสินธุ์": "Kalasin",
  "กำแพงเพชร": "Kamphaeng Phet",
  "ขอนแก่น": "Khon Kaen",
  "จันทบุรี": "Chanthaburi",
  "ฉะเชิงเทรา": "Chachoengsao",
  "ชลบุรี": "Chon Buri",
  "ชัยนาท": "Chai Nat",
  "ชัยภูมิ": "Chaiyaphum",
  "ชุมพร": "Chumphon",
  "เชียงราย": "Chiang Rai",
  "เชียงใหม่": "Chiang Mai",
  "ตรัง": "Trang",
  "ตราด": "Trat",
  "ตาก": "Tak",
  "นครนายก": "Nakhon Nayok",
  "นครปฐม": "Nakhon Pathom",
  "นครพนม": "Nakhon Phanom",
  "นครราชสีมา": "Nakhon Ratchasima",
  "นครศรีธรรมราช": "Nakhon Si Thammarat",
  "นครสวรรค์": "Nakhon Sawan",
  "นนทบุรี": "Nonthaburi",
  "นราธิวาส": "Narathiwat",
  "น่าน": "Nan",
  "บึงกาฬ": "Bueng Kan",
  "บุรีรัมย์": "Buri Ram",
  "ปทุมธานี": "Pathum Thani",
  "ประจวบคีรีขันธ์": "Prachuap Khiri Khan",
  "ปราจีนบุรี": "Prachin Buri",
  "ปัตตานี": "Pattani",
  "พระนครศรีอยุธยา": "Phra Nakhon Si Ayutthaya",
  "พังงา": "Phang Nga",
  "พัทลุง": "Phatthalung",
  "พิจิตร": "Phichit",
  "พิษณุโลก": "Phitsanulok",
  "เพชรบุรี": "Phetchaburi",
  "เพชรบูรณ์": "Phetchabun",
  "แพร่": "Phrae",
  "ภูเก็ต": "Phuket",
  "มหาสารคาม": "Maha Sarakham",
  "มุกดาหาร": "Mukdahan",
  "แม่ฮ่องสอน": "Mae Hong Son",
  "ยะลา": "Yala",
  "ยโสธร": "Yasothon",
  "ร้อยเอ็ด": "Roi Et",
  "ระนอง": "Ranong",
  "ระยอง": "Rayong",
  "ราชบุรี": "Ratchaburi",
  "ลพบุรี": "Lop Buri",
  "ลำปาง": "Lampang",
  "ลำพูน": "Lamphun",
  "เลย": "Loei",
  "ศรีสะเกษ": "Si Sa Ket",
  "สกลนคร": "Sakon Nakhon",
  "สงขลา": "Songkhla",
  "สตูล": "Satun",
  "สมุทรปราการ": "Samut Prakan",
  "สมุทรสงคราม": "Samut Songkhram",
  "สมุทรสาคร": "Samut Sakhon",
  "สระบุรี": "Saraburi",
  "สระแก้ว": "Sa Kaeo",
  "สิงห์บุรี": "Sing Buri",
  "สุโขทัย": "Sukhothai",
  "สุพรรณบุรี": "Suphan Buri",
  "สุราษฎร์ธานี": "Surat Thani",
  "สุรินทร์": "Surin",
  "หนองคาย": "Nong Khai",
  "หนองบัวลำภู": "Nong Bua Lam Phu",
  "อำนาจเจริญ": "Amnat Charoen",
  "อุดรธานี": "Udon Thani",
  "อุตรดิตถ์": "Uttaradit",
  "อุทัยธานี": "Uthai Thani",
  "อุบลราชธานี": "Ubon Ratchathani",
  "อ่างทอง": "Ang Thong",
  "พะเยา": "Phayao"
};

export default provinceEn;
